import { DashboardGroup, DashboardItem } from '@Models';

/**
 * Get the first dashboard id from either flat, grouped, or mixed structure
 */
const getFirstDashboardId = (dashboards: DashboardItem[] | DashboardGroup[] | undefined): string | undefined => {
  if (!dashboards || dashboards.length === 0) return undefined;

  // Get the first dashboard from mixed structure
  const firstItem = dashboards[0];

  if ('group' in firstItem) {
    // First item is grouped, get first dashboard from the group
    const group = firstItem;
    return group.dashboards[0]?.id;
  }

  // First item is individual dashboard
  const individualDashboard = firstItem;
  return individualDashboard.id;
};

/**
 * Get the first dashboard item from either flat, grouped, or mixed structure
 */
const getFirstDashboard = (dashboards: DashboardItem[] | DashboardGroup[] | undefined): DashboardItem | undefined => {
  if (!dashboards || dashboards.length === 0) return undefined;

  const firstItem = dashboards[0];

  if ('group' in firstItem) {
    return firstItem.dashboards[0];
  }

  return firstItem;
};

/**
 * Find a dashboard by ID from either flat, grouped, or mixed structure.
 */
const getDashboardById = (
  dashboards: DashboardItem[] | DashboardGroup[] | undefined,
  id: string | undefined,
): DashboardItem | undefined => {
  if (!dashboards || !id) return undefined;

  const allDashboards = dashboards.flatMap((item) => ('group' in item ? item.dashboards : [item as DashboardItem]));

  return allDashboards.find((d) => d.id === id);
};

const buildMonitorLink = (dashboard: DashboardItem): string => `/monitor/${dashboard.id}`;

export default getFirstDashboardId;
export { buildMonitorLink, getDashboardById, getFirstDashboard };
